/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../Fixes';
import Builder from '../../../../Builder';
import '../../../common/currency';
import '../../../common/time';
import './models/offers';
import '../../../common/countries';
import '../../common';
import '../../offer/models';
import '../../servicing/plan/models';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "capital": {
        "nested": {
          "external": {
            "nested": {
              "business": {
                "nested": {
                  "models": {
                    "nested": {
                      "AfcStatus": {
                        "fields": {
                          "customerToken": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "status": {
                            "type": ".squareup.capital.external.business.models.AfcStatus.Status",
                            "id": 2,
                            "rule": "optional"
                          },
                          "reviewStatus": {
                            "type": ".squareup.capital.external.business.models.AfcStatus.ReviewStatus",
                            "id": 3,
                            "rule": "optional"
                          },
                          "reviewPercentage": {
                            "type": "int32",
                            "id": 4,
                            "rule": "optional"
                          },
                          "newMaxOffer": {
                            "type": ".squareup.common.Money",
                            "id": 5,
                            "rule": "optional"
                          },
                          "previousMaxOffer": {
                            "type": ".squareup.common.Money",
                            "id": 6,
                            "rule": "optional"
                          },
                          "bankAccountLastFour": {
                            "type": "string",
                            "id": 7,
                            "rule": "optional"
                          },
                          "adverseActionReasons": {
                            "type": "string",
                            "id": 8,
                            "rule": "repeated"
                          }
                        },
                        "nested": {
                          "Status": {
                            "values": {
                              "S_DO_NOT_USE": 0,
                              "MAY_APPLY": 1,
                              "MAY_NOT_APPLY": 2,
                              "AUTO_REVIEW": 3,
                              "MANUAL_REVIEW": 4,
                              "APPROVED": 5,
                              "DECLINED": 6,
                              "AUTO_REVIEW_TIMEOUT": 7,
                              "CREDIT_PROFILE_LOCKED": 8,
                              "CREDIT_PROFILE_FROZEN": 9,
                              "NO_CREDIT_PROFILE_MATCH_WITHOUT_SSN": 10
                            }
                          },
                          "ReviewStatus": {
                            "values": {
                              "RS_DO_NOT_USE": 0,
                              "CONTACTING_BANK": 1,
                              "VALIDATING_ACCOUNTS": 2,
                              "COLLECTING_TRANSACTIONS": 3,
                              "ANALYZING_INFO": 4
                            }
                          }
                        }
                      },
                      "ControllingIndividual": {
                        "nested": {
                          "Title": {
                            "values": {
                              "DO_NOT_USE_CONTROLLING_INDIVIDUAL_TITLE": 0,
                              "NO_TITLE": 1,
                              "BUSINESS_MANAGER": 2,
                              "CEO": 3,
                              "CFO": 4,
                              "COO": 5,
                              "MANAGING_MEMBER": 6,
                              "GENERAL_PARTNER": 7,
                              "PRESIDENT": 8,
                              "VICE_PRESIDENT": 9,
                              "TREASURER": 10,
                              "OTHER_MANAGER": 11,
                              "DIRECTOR": 12
                            }
                          }
                        }
                      },
                      "InformationRequest": {
                        "fields": {
                          "isComplete": {
                            "type": "bool",
                            "id": 1,
                            "rule": "optional"
                          },
                          "source": {
                            "type": ".squareup.capital.external.business.models.InformationRequest.Source",
                            "id": 4,
                            "rule": "optional"
                          },
                          "irfForm": {
                            "type": ".squareup.capital.external.business.models.InformationRequest.IrfForm",
                            "id": 2
                          },
                          "sspRequest": {
                            "type": ".squareup.capital.external.business.models.InformationRequest.SspRequest",
                            "id": 3
                          },
                          "kbaRequest": {
                            "type": ".squareup.capital.external.business.models.InformationRequest.KbaRequest",
                            "id": 5
                          }
                        },
                        "nested": {
                          "Source": {
                            "values": {
                              "IR_SOURCE_DO_NO_USE": 0,
                              "RISK": 1,
                              "COMPLIANCE": 2
                            }
                          },
                          "IrfForm": {
                            "fields": {
                              "url": {
                                "type": "string",
                                "id": 1,
                                "rule": "optional"
                              }
                            }
                          },
                          "SspRequest": {
                            "fields": {}
                          },
                          "KbaRequest": {
                            "fields": {}
                          },
                          "type_data": {
                            "oneof": ["irfForm", "sspRequest", "kbaRequest"]
                          }
                        }
                      },
                      "FinancingRequest": {
                        "fields": {
                          "token": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "customerToken": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "status": {
                            "type": ".squareup.capital.external.business.models.FinancingRequest.Status",
                            "id": 3,
                            "rule": "optional"
                          },
                          "informationRequests": {
                            "type": ".squareup.capital.external.business.models.InformationRequest",
                            "id": 4,
                            "rule": "repeated"
                          },
                          "expiresAtDate": {
                            "type": ".squareup.common.time.YearMonthDay",
                            "id": 5,
                            "rule": "optional"
                          },
                          "selectedOffer": {
                            "type": ".squareup.capital.external.business.models.offers.Offer",
                            "id": 6,
                            "rule": "optional"
                          },
                          "applicantEmail": {
                            "type": "string",
                            "id": 7,
                            "rule": "optional"
                          },
                          "waitPendingExtraPayment": {
                            "type": "bool",
                            "id": 8,
                            "rule": "optional"
                          },
                          "countryCode": {
                            "type": ".squareup.common.countries.Country",
                            "id": 9,
                            "rule": "optional"
                          },
                          "isConditionallyApproved": {
                            "type": "bool",
                            "id": 10,
                            "rule": "optional"
                          },
                          "isPppLoanApplication": {
                            "type": "bool",
                            "id": 11,
                            "rule": "optional"
                          },
                          "hasCounterOffer": {
                            "type": "bool",
                            "id": 12,
                            "rule": "optional"
                          },
                          "isPppForgivenessApplication": {
                            "type": "bool",
                            "id": 13,
                            "rule": "optional"
                          },
                          "submittedAt": {
                            "type": "string",
                            "id": 14,
                            "rule": "optional"
                          },
                          "requestedPppForgivenessMoney": {
                            "type": ".squareup.common.Money",
                            "id": 15,
                            "rule": "optional"
                          },
                          "loanAgreementUrl": {
                            "type": "string",
                            "id": 16,
                            "rule": "optional"
                          },
                          "pppForgivenessFormType": {
                            "type": ".squareup.capital.external.business.models.FinancingRequest.PppForgivenessFormType",
                            "id": 17,
                            "rule": "optional"
                          },
                          "nickname": {
                            "type": "string",
                            "id": 18,
                            "rule": "optional"
                          },
                          "loanDepositLocation": {
                            "type": ".squareup.capital.common.LoanDepositLocation",
                            "id": 19,
                            "rule": "optional",
                            "options": {
                              "default": "LINKED_BANK_ACCOUNT"
                            }
                          }
                        },
                        "nested": {
                          "Status": {
                            "values": {
                              "FR_STATUS_DO_NOT_USE": 0,
                              "PENDING": 1,
                              "SUBMITTED": 2,
                              "APPROVED": 3,
                              "DECLINED": 4,
                              "CANCELED": 5,
                              "MANUAL_REVIEW": 6,
                              "SBA_REVIEW": 7,
                              "COMPLETED": 8,
                              "AWAITING_SBA_SUBMISSION": 9,
                              "AUTO_REVIEW": 10,
                              "AWAITING_REUPLOAD": 11,
                              "MANUAL_REVIEW_COMPLETED": 12,
                              "SBA_SUBMISSION": 13,
                              "SBA_SUBMISSION_FAILED": 14
                            }
                          },
                          "PppForgivenessFormType": {
                            "values": {
                              "PFFT_DO_NOT_USE": 0,
                              "NONE": 1,
                              "FORM_3508EZ": 2,
                              "FORM_3508S": 3
                            }
                          }
                        }
                      },
                      "PaymentBreakdown": {
                        "fields": {
                          "offerToken": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "averageCardSaleMoney": {
                            "type": ".squareup.common.Money",
                            "id": 2,
                            "rule": "optional"
                          },
                          "processingFeeMoney": {
                            "type": ".squareup.common.Money",
                            "id": 3,
                            "rule": "optional"
                          },
                          "loanPaymentMoney": {
                            "type": ".squareup.common.Money",
                            "id": 4,
                            "rule": "optional"
                          },
                          "salesEarnedMoney": {
                            "type": ".squareup.common.Money",
                            "id": 5,
                            "rule": "optional"
                          }
                        }
                      },
                      "OfferSimulation": {
                        "fields": {
                          "offerId": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "payments": {
                            "type": ".squareup.capital.external.business.models.OfferPayment",
                            "id": 2,
                            "rule": "repeated"
                          }
                        }
                      },
                      "OfferPayment": {
                        "fields": {
                          "date": {
                            "type": ".squareup.common.time.DateTime",
                            "id": 1,
                            "rule": "optional"
                          },
                          "totalPaymentAmount": {
                            "type": ".squareup.common.Money",
                            "id": 2,
                            "rule": "optional"
                          },
                          "totalCapitalPaymentAmount": {
                            "type": ".squareup.common.Money",
                            "id": 3,
                            "rule": "optional"
                          }
                        }
                      },
                      "CustomerMaxOfferAmount": {
                        "fields": {
                          "maxFinancedAmount": {
                            "type": ".squareup.common.Money",
                            "id": 1,
                            "rule": "optional"
                          },
                          "customerToken": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "customerExternalToken": {
                            "type": "string",
                            "id": 3,
                            "rule": "optional"
                          }
                        }
                      },
                      "PreviewBoostOffer": {
                        "fields": {
                          "boostMaxFinancedAmount": {
                            "type": ".squareup.common.Money",
                            "id": 1,
                            "rule": "optional"
                          },
                          "ficoPullStatus": {
                            "type": ".squareup.capital.offer.models.BizConfiguration.FicoPullStatus",
                            "id": 2,
                            "rule": "optional"
                          },
                          "plaidLinkStatus": {
                            "type": ".squareup.capital.offer.models.BizConfiguration.PlaidLinkStatus",
                            "id": 3,
                            "rule": "optional"
                          },
                          "isPreview": {
                            "type": "bool",
                            "id": 4,
                            "rule": "optional"
                          }
                        }
                      },
                      "PreviewOffer": {
                        "fields": {
                          "offerSetId": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "product": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "offerSelectionUrl": {
                            "type": "string",
                            "id": 3,
                            "rule": "optional"
                          },
                          "maxFinancedAmount": {
                            "type": ".squareup.common.Money",
                            "id": 4,
                            "rule": "optional"
                          },
                          "rfc3986OfferSelectionUrl": {
                            "type": "string",
                            "id": 5,
                            "rule": "optional"
                          },
                          "previewBoostOffer": {
                            "type": ".squareup.capital.external.business.models.PreviewBoostOffer",
                            "id": 7,
                            "rule": "optional"
                          },
                          "createdAt": {
                            "type": ".squareup.common.time.DateTime",
                            "id": 8,
                            "rule": "optional"
                          },
                          "productType": {
                            "type": ".squareup.capital.external.business.models.ProductType",
                            "id": 9,
                            "rule": "optional"
                          },
                          "productName": {
                            "type": ".squareup.capital.common.ProductName",
                            "id": 10,
                            "rule": "optional"
                          }
                        }
                      },
                      "PreviewFinancingRequest": {
                        "fields": {
                          "financingRequestId": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "status": {
                            "type": ".squareup.capital.external.business.models.ApplicationStatus",
                            "id": 2,
                            "rule": "optional"
                          },
                          "type": {
                            "type": ".squareup.capital.external.business.models.ApplicationType",
                            "id": 3,
                            "rule": "optional"
                          },
                          "product": {
                            "type": "string",
                            "id": 4,
                            "rule": "optional"
                          },
                          "financingAmount": {
                            "type": ".squareup.common.Money",
                            "id": 5,
                            "rule": "optional"
                          },
                          "productType": {
                            "type": ".squareup.capital.external.business.models.ProductType",
                            "id": 6,
                            "rule": "optional"
                          },
                          "productName": {
                            "type": ".squareup.capital.common.ProductName",
                            "id": 7,
                            "rule": "optional"
                          }
                        }
                      },
                      "ProductType": {
                        "values": {
                          "PT_DO_NOT_USE": 0,
                          "LOAN": 1,
                          "MCA": 2,
                          "RISA": 3,
                          "MCA_GLOBAL": 4,
                          "LINE_OF_CREDIT": 5
                        }
                      },
                      "PreviewPlan": {
                        "fields": {
                          "planId": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "planServicingUrl": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "legacyPlanId": {
                            "type": "string",
                            "id": 3,
                            "rule": "optional"
                          },
                          "productType": {
                            "type": ".squareup.capital.external.business.models.ProductType",
                            "id": 4,
                            "rule": "optional"
                          },
                          "rfc3986PlanServicingUrl": {
                            "type": "string",
                            "id": 5,
                            "rule": "optional"
                          },
                          "planStatus": {
                            "type": ".squareup.capital.servicing.plan.models.Plan.Status",
                            "id": 6,
                            "rule": "optional"
                          },
                          "canReceiveMpo": {
                            "type": "bool",
                            "id": 7,
                            "rule": "optional"
                          },
                          "eligibilityToolEnabled": {
                            "type": "bool",
                            "id": 8,
                            "rule": "optional"
                          },
                          "productName": {
                            "type": ".squareup.capital.common.ProductName",
                            "id": 9,
                            "rule": "optional"
                          }
                        }
                      },
                      "ApplicationStatus": {
                        "values": {
                          "AS_DO_NOT_USE": 0,
                          "PENDING": 1,
                          "IN_REVIEW": 2,
                          "DECLINED": 3,
                          "APPROVED": 4
                        }
                      },
                      "ApplicationType": {
                        "values": {
                          "AT_DO_NOT_USE": 0,
                          "BUSINESS_LOAN": 1,
                          "ONBOARDING_LOAN": 2
                        }
                      },
                      "ReviewType": {
                        "values": {
                          "RT_DO_NOT_USE": 0,
                          "AUTO": 1,
                          "MANUAL": 2
                        }
                      },
                      "PreviewOfferFlow": {
                        "fields": {
                          "offerFlowId": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "status": {
                            "type": ".squareup.capital.external.business.models.ApplicationStatus",
                            "id": 2,
                            "rule": "optional"
                          },
                          "reviewType": {
                            "type": ".squareup.capital.external.business.models.ReviewType",
                            "id": 3,
                            "rule": "optional"
                          }
                        }
                      },
                      "EligibilityType": {
                        "values": {
                          "ET_DO_NOT_USE": 0,
                          "APPLY_FOR_OFFER": 1,
                          "APPLY_FOR_PPP_OFFER": 2,
                          "APPLY_FOR_PPP_FORGIVENESS": 3,
                          "WAS_ALLOWED_TO_APPLY_FOR_PPP_OFFER_BEFORE_CUTOFF": 4,
                          "APPLY_FOR_PPP_OFFER_FIRST_DRAW": 5,
                          "BE_DECISIONED_FOR_FLEX_OFFER": 6,
                          "APPLY_FOR_PPP_FORGIVENESS_R2": 7,
                          "APPLY_FOR_ONBOARDING_LOAN": 8,
                          "FLEX_PRODUCT_IS_AVAILABLE": 9,
                          "MCA_GLOBAL_PRODUCT_IS_AVAILABLE": 10
                        }
                      },
                      "Eligibility": {
                        "fields": {
                          "type": {
                            "type": ".squareup.capital.external.business.models.EligibilityType",
                            "id": 1,
                            "rule": "optional"
                          },
                          "expiredAt": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          }
                        }
                      },
                      "Customer": {
                        "fields": {
                          "id": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "partnerId": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "createdAt": {
                            "type": ".squareup.common.time.DateTime",
                            "id": 3,
                            "rule": "optional"
                          },
                          "previewMainOffer": {
                            "type": ".squareup.capital.external.business.models.PreviewOffer",
                            "id": 4,
                            "rule": "optional"
                          },
                          "previewFinancingRequestInReview": {
                            "type": ".squareup.capital.external.business.models.PreviewFinancingRequest",
                            "id": 5,
                            "rule": "optional"
                          },
                          "previewActivePlan": {
                            "type": ".squareup.capital.external.business.models.PreviewPlan",
                            "id": 6,
                            "rule": "optional"
                          },
                          "previewLatestCompletedPlan": {
                            "type": ".squareup.capital.external.business.models.PreviewPlan",
                            "id": 7,
                            "rule": "optional"
                          },
                          "previewLatestClosedPlan": {
                            "type": ".squareup.capital.external.business.models.PreviewPlan",
                            "id": 11,
                            "rule": "optional"
                          },
                          "eligibilities": {
                            "type": ".squareup.capital.external.business.models.Eligibility",
                            "id": 8,
                            "rule": "repeated"
                          },
                          "previewOfferFlow": {
                            "type": ".squareup.capital.external.business.models.PreviewOfferFlow",
                            "id": 9,
                            "rule": "optional"
                          },
                          "previewFinancingRequest": {
                            "type": ".squareup.capital.external.business.models.PreviewFinancingRequest",
                            "id": 10,
                            "rule": "optional"
                          },
                          "previewActivePlans": {
                            "type": ".squareup.capital.external.business.models.PreviewPlan",
                            "id": 12,
                            "rule": "repeated"
                          },
                          "previewFinancingRequests": {
                            "type": ".squareup.capital.external.business.models.PreviewFinancingRequest",
                            "id": 13,
                            "rule": "repeated"
                          },
                          "mdsCreatedAt": {
                            "type": ".squareup.common.time.DateTime",
                            "id": 14,
                            "rule": "optional"
                          },
                          "activatedAt": {
                            "type": "string",
                            "id": 15,
                            "rule": "optional"
                          },
                          "previewOffers": {
                            "type": ".squareup.capital.external.business.models.PreviewOffer",
                            "id": 16,
                            "rule": "repeated"
                          }
                        }
                      },
                      "CustomerEligibility": {
                        "fields": {
                          "customerId": {
                            "type": "string",
                            "id": 6,
                            "rule": "optional"
                          },
                          "lastUpdatedAt": {
                            "type": "string",
                            "id": 7,
                            "rule": "optional"
                          },
                          "extraIneligibleReasons": {
                            "type": ".squareup.capital.external.business.models.CustomerEligibility.IneligibleReason",
                            "id": 2,
                            "rule": "repeated"
                          },
                          "paymentVolume": {
                            "type": ".squareup.capital.external.business.models.CustomerEligibility.PaymentVolume",
                            "id": 3,
                            "rule": "optional"
                          },
                          "paymentFrequency": {
                            "type": ".squareup.capital.external.business.models.CustomerEligibility.PaymentFrequency",
                            "id": 8,
                            "rule": "optional"
                          },
                          "processingVolume": {
                            "type": ".squareup.capital.external.business.models.CustomerEligibility.ProcessingVolume",
                            "id": 9,
                            "rule": "optional"
                          },
                          "processingFrequency": {
                            "type": ".squareup.capital.external.business.models.CustomerEligibility.ProcessingFrequency",
                            "id": 10,
                            "rule": "optional"
                          },
                          "customerMix": {
                            "type": ".squareup.capital.external.business.models.CustomerEligibility.CustomerMix",
                            "id": 11,
                            "rule": "optional"
                          },
                          "firstProcessingDate": {
                            "type": ".squareup.common.time.DateTime",
                            "id": 12,
                            "rule": "optional"
                          },
                          "numberOfDisputes": {
                            "type": "int64",
                            "id": 13,
                            "rule": "optional"
                          },
                          "hideEligibilityToolSections": {
                            "type": ".squareup.capital.external.business.models.CustomerEligibility.EligibilityToolSection",
                            "id": 14,
                            "rule": "repeated"
                          },
                          "last52wActiveDayCount": {
                            "type": "int64",
                            "id": 15,
                            "rule": "optional"
                          }
                        },
                        "nested": {
                          "Status": {
                            "values": {
                              "STATUS_DO_NOT_USE": 0,
                              "NEED_WORK": 1,
                              "GOOD": 2,
                              "GREAT": 3,
                              "NOT_AVAILABLE": 4
                            }
                          },
                          "IneligibleReason": {
                            "values": {
                              "IR_DO_NOT_USE": 0,
                              "FROZEN": 1,
                              "CHARGEBACK_COUNT_TOO_LARGE": 2,
                              "CASH_ADVANCE_PLAN_DECLINED": 3,
                              "INELIGIBLE_BUSINESS_TYPE": 4,
                              "RECENT_APPLICATIONS": 5,
                              "ACCOUNT_HISTORY": 6,
                              "PERMANENTLY_BLOCKED": 7,
                              "TEMPORARILY_BLOCKED": 8,
                              "MPO_INELIGIBLE": 9,
                              "REASONS_NOT_AVAILABLE": 10,
                              "RECENT_LOAN_PREPAYMENT": 11,
                              "ACTIVE_DAY_COUNT_BELOW_MINIMUM": 12,
                              "PAYMENT_LIMIT": 13,
                              "ACTIVE_RESERVES": 14
                            }
                          },
                          "EligibilityToolSection": {
                            "values": {
                              "DO_NOT_USE": 0,
                              "LOAN_PREPAYMENTS": 1,
                              "ACCOUNT_REVIEWS": 2,
                              "PRIOR_LOAN_APPLICATIONS": 3,
                              "PAYMENT_DISPUTES": 4,
                              "HISTORY_WITH_SQUARE": 5,
                              "PAYMENT_LIMITS": 6,
                              "RESERVES": 7
                            }
                          },
                          "PaymentVolume": {
                            "fields": {
                              "status": {
                                "type": ".squareup.capital.external.business.models.CustomerEligibility.Status",
                                "id": 1,
                                "rule": "optional"
                              },
                              "volume12Months": {
                                "type": ".squareup.common.Money",
                                "id": 2,
                                "rule": "optional"
                              },
                              "minVolume12Months": {
                                "type": ".squareup.common.Money",
                                "id": 3,
                                "rule": "optional"
                              }
                            }
                          },
                          "PaymentFrequency": {
                            "fields": {
                              "status": {
                                "type": ".squareup.capital.external.business.models.CustomerEligibility.Status",
                                "id": 1,
                                "rule": "optional"
                              },
                              "lastCardPaymentAt": {
                                "type": "string",
                                "id": 2,
                                "rule": "optional"
                              },
                              "activeDayCount": {
                                "type": "uint32",
                                "id": 5,
                                "rule": "optional"
                              },
                              "activeDayCountWindow": {
                                "type": "uint32",
                                "id": 6,
                                "rule": "optional"
                              }
                            }
                          },
                          "ProcessingVolume": {
                            "fields": {
                              "last52wStatus": {
                                "type": ".squareup.capital.external.business.models.CustomerEligibility.Status",
                                "id": 1,
                                "rule": "optional"
                              },
                              "last52wVolumes": {
                                "type": ".squareup.common.Money",
                                "id": 2,
                                "rule": "repeated"
                              },
                              "average4wVolume": {
                                "type": ".squareup.common.Money",
                                "id": 3,
                                "rule": "optional"
                              },
                              "last4wStatus": {
                                "type": ".squareup.capital.external.business.models.CustomerEligibility.Status",
                                "id": 4,
                                "rule": "optional"
                              },
                              "last4wVolumes": {
                                "type": ".squareup.common.Money",
                                "id": 5,
                                "rule": "repeated"
                              },
                              "min1yVolume": {
                                "type": ".squareup.common.Money",
                                "id": 6,
                                "rule": "optional"
                              },
                              "projectedGrowth": {
                                "type": ".squareup.common.Money",
                                "id": 7,
                                "rule": "optional"
                              },
                              "projectedGrowthStatus": {
                                "type": ".squareup.capital.external.business.models.CustomerEligibility.Status",
                                "id": 8,
                                "rule": "optional"
                              },
                              "last7dStatus": {
                                "type": ".squareup.capital.external.business.models.CustomerEligibility.Status",
                                "id": 9,
                                "rule": "optional"
                              }
                            }
                          },
                          "ProcessingFrequency": {
                            "fields": {
                              "last52wStatus": {
                                "type": ".squareup.capital.external.business.models.CustomerEligibility.Status",
                                "id": 1,
                                "rule": "optional"
                              },
                              "last52wFrequencies": {
                                "type": "double",
                                "id": 2,
                                "rule": "repeated"
                              },
                              "avg4wFrequency": {
                                "type": "double",
                                "id": 3,
                                "rule": "optional"
                              },
                              "last4wStatus": {
                                "type": ".squareup.capital.external.business.models.CustomerEligibility.Status",
                                "id": 4,
                                "rule": "optional"
                              },
                              "last4wFrequencies": {
                                "type": "double",
                                "id": 5,
                                "rule": "repeated"
                              },
                              "last7dStatus": {
                                "type": ".squareup.capital.external.business.models.CustomerEligibility.Status",
                                "id": 6,
                                "rule": "optional"
                              }
                            }
                          },
                          "CustomerMix": {
                            "fields": {
                              "last4wStatus": {
                                "type": ".squareup.capital.external.business.models.CustomerEligibility.Status",
                                "id": 1,
                                "rule": "optional"
                              },
                              "last4wCustomers": {
                                "type": "double",
                                "id": 2,
                                "rule": "repeated"
                              }
                            }
                          }
                        }
                      },
                      "BankAccountData": {
                        "fields": {
                          "bankName": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "bankAccountSuffix": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          }
                        }
                      },
                      "PPPOfferFlow": {
                        "fields": {
                          "offerFlowToken": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "averageMonthlyPayrollAmountCents": {
                            "type": "int64",
                            "id": 2,
                            "rule": "optional"
                          },
                          "outstandingEidlAmountCents": {
                            "type": "uint64",
                            "id": 3,
                            "rule": "optional"
                          },
                          "numberOfEmployees": {
                            "type": "uint32",
                            "id": 4,
                            "rule": "optional"
                          },
                          "hasEmployeesPaidOver100k": {
                            "type": "bool",
                            "id": 5,
                            "rule": "optional"
                          },
                          "isSeasonalBusiness": {
                            "type": "bool",
                            "id": 6,
                            "rule": "optional"
                          },
                          "onlyProcessedOnSquare2019": {
                            "type": "bool",
                            "id": 7,
                            "rule": "optional"
                          },
                          "businessStartedIn2020": {
                            "type": "bool",
                            "id": 8,
                            "rule": "optional"
                          },
                          "businessEstablishedDate": {
                            "type": ".squareup.common.time.YearMonthDay",
                            "id": 9,
                            "rule": "optional"
                          },
                          "hasReceivedEidl": {
                            "type": "bool",
                            "id": 10,
                            "rule": "optional"
                          },
                          "annualGrossPayToEmployeesCents": {
                            "type": "uint64",
                            "id": 11,
                            "rule": "optional"
                          },
                          "annualStateAndLocalTaxesPaidCents": {
                            "type": "uint64",
                            "id": 12,
                            "rule": "optional"
                          },
                          "hasOfferedHealthOrRetirementBenefits": {
                            "type": "bool",
                            "id": 13,
                            "rule": "optional"
                          },
                          "annualHealthBenefitsCents": {
                            "type": "uint64",
                            "id": 14,
                            "rule": "optional"
                          },
                          "annualRetirementBenefitsCents": {
                            "type": "uint64",
                            "id": 15,
                            "rule": "optional"
                          },
                          "annualExcessEmployeeCompensationCents": {
                            "type": "uint64",
                            "id": 16,
                            "rule": "optional"
                          },
                          "payrollCalculationDoc": {
                            "type": ".squareup.capital.external.business.models.PPPOfferFlow.PayrollCalculationDoc",
                            "id": 17,
                            "rule": "optional"
                          },
                          "plaidLinkageVendorSnapshotToken": {
                            "type": "string",
                            "id": 18,
                            "rule": "optional"
                          },
                          "useSquarePayrollPrefill": {
                            "type": "bool",
                            "id": 19,
                            "rule": "optional"
                          },
                          "canPrefillSquarePayrollData": {
                            "type": "bool",
                            "id": 20,
                            "rule": "optional"
                          },
                          "squarePayrollPppData": {
                            "type": ".squareup.capital.external.business.models.PPPOfferFlow.SquarePayrollPPPData",
                            "id": 21,
                            "rule": "optional"
                          },
                          "annualNetProfitCents": {
                            "type": "uint64",
                            "id": 22,
                            "rule": "optional"
                          },
                          "businessEntityType": {
                            "type": ".squareup.capital.common.BusinessEntityType",
                            "id": 23,
                            "rule": "optional"
                          },
                          "status": {
                            "type": ".squareup.capital.external.business.models.AfcStatus",
                            "id": 24,
                            "rule": "optional"
                          },
                          "numberOfQuarterly941Documents": {
                            "type": "int32",
                            "id": 25,
                            "rule": "optional"
                          },
                          "verifiedAverageMonthlyPayrollAmountCents2019": {
                            "type": "int64",
                            "id": 26,
                            "rule": "optional"
                          },
                          "useVerifiedAverageMonthlyPayrollAmountCents2019": {
                            "type": "bool",
                            "id": 27,
                            "rule": "optional"
                          },
                          "verifiedOwnerCompensationAmountCents2019": {
                            "type": "int64",
                            "id": 28,
                            "rule": "optional"
                          },
                          "useVerifiedOwnerCompensationAmountCents2019": {
                            "type": "bool",
                            "id": 29,
                            "rule": "optional"
                          },
                          "naicsCode": {
                            "type": "string",
                            "id": 30,
                            "rule": "optional"
                          },
                          "has25pctGrossReceiptsReduction": {
                            "type": ".squareup.capital.external.business.models.PPPOfferFlow.NullableBool",
                            "id": 31,
                            "rule": "optional"
                          },
                          "payrollYear": {
                            "type": ".squareup.capital.external.business.models.PPPOfferFlow.PayrollYear",
                            "id": 32,
                            "rule": "optional"
                          },
                          "maxNumberOfEmployees": {
                            "type": "uint32",
                            "id": 33,
                            "rule": "optional"
                          },
                          "businessCategory": {
                            "type": "string",
                            "id": 34,
                            "rule": "optional"
                          },
                          "use2019ScheduleCConfirmed": {
                            "type": ".squareup.capital.external.business.models.PPPOfferFlow.ScheduleCConfirmation",
                            "id": 35,
                            "rule": "optional"
                          },
                          "offerAmountCentsRound1": {
                            "type": "int64",
                            "id": 36,
                            "rule": "optional"
                          },
                          "docboxTokens": {
                            "type": "string",
                            "id": 37,
                            "rule": "repeated"
                          },
                          "pppDrawType": {
                            "type": ".squareup.capital.external.business.models.PPPOfferFlow.PppDrawType",
                            "id": 38,
                            "rule": "optional"
                          },
                          "fieldKeyToDocboxTokens": {
                            "type": ".squareup.capital.external.business.models.PPPOfferFlow.DocboxTokens",
                            "id": 39,
                            "keyType": "string"
                          },
                          "originalBusinessEntityType": {
                            "type": ".squareup.capital.common.BusinessEntityType",
                            "id": 40,
                            "rule": "optional"
                          },
                          "hasW2Employees": {
                            "type": ".squareup.capital.external.business.models.PPPOfferFlow.NullableBool",
                            "id": 41,
                            "rule": "optional"
                          },
                          "squarePayrollData2019": {
                            "type": ".squareup.capital.external.business.models.PPPOfferFlow.SquarePayrollPPPData",
                            "id": 42,
                            "rule": "optional"
                          },
                          "squarePayrollData2020": {
                            "type": ".squareup.capital.external.business.models.PPPOfferFlow.SquarePayrollPPPData",
                            "id": 43,
                            "rule": "optional"
                          },
                          "hasOfferedHealthBenefits": {
                            "type": ".squareup.capital.external.business.models.PPPOfferFlow.NullableBool",
                            "id": 44,
                            "rule": "optional"
                          },
                          "healthBenefitsDocumentType": {
                            "type": ".squareup.capital.external.business.models.PPPOfferFlow.BenefitsDocType",
                            "id": 45,
                            "rule": "optional"
                          },
                          "hasOfferedRetirementBenefits": {
                            "type": ".squareup.capital.external.business.models.PPPOfferFlow.NullableBool",
                            "id": 46,
                            "rule": "optional"
                          },
                          "retirementBenefitsDocumentType": {
                            "type": ".squareup.capital.external.business.models.PPPOfferFlow.BenefitsDocType",
                            "id": 47,
                            "rule": "optional"
                          },
                          "useSquarePayrollDataConfirmed": {
                            "type": "bool",
                            "id": 48,
                            "rule": "optional"
                          },
                          "seasonalPayPeriodStartDate": {
                            "type": ".squareup.common.time.YearMonthDay",
                            "id": 49,
                            "rule": "optional"
                          },
                          "isSquarePayrollMerchant": {
                            "type": "bool",
                            "id": 50,
                            "rule": "optional"
                          },
                          "squarePayrollDataNewBusiness": {
                            "type": ".squareup.capital.external.business.models.PPPOfferFlow.SquarePayrollPPPData",
                            "id": 51,
                            "rule": "optional"
                          },
                          "squarePayrollDataSeasonalBusiness": {
                            "type": ".squareup.capital.external.business.models.PPPOfferFlow.SquarePayrollPPPData",
                            "id": 52,
                            "rule": "optional"
                          },
                          "grossIncomeCents": {
                            "type": "uint64",
                            "id": 53,
                            "rule": "optional"
                          },
                          "employeeBenefitExpensesCents": {
                            "type": "uint64",
                            "id": 54,
                            "rule": "optional"
                          },
                          "pensionProfitSharingPlansCents": {
                            "type": "uint64",
                            "id": 55,
                            "rule": "optional"
                          },
                          "wagesLessEmploymentCreditsCents": {
                            "type": "uint64",
                            "id": 56,
                            "rule": "optional"
                          }
                        },
                        "nested": {
                          "PayrollCalculationDoc": {
                            "values": {
                              "DO_NOT_USE": 0,
                              "TAX_FORM_940": 1,
                              "TAX_FORM_944": 2,
                              "TAX_FORM_W3": 3,
                              "QUARTERLY_TAX_FORM_941": 4,
                              "PAYROLL_REPORT_2019": 5,
                              "PAYROLL_REPORT_LAST_12_MONTHS": 6,
                              "PPP_CARES_ACT_REPORT": 7
                            }
                          },
                          "SquarePayrollPPPData": {
                            "fields": {
                              "averageMonthlyPayrollAmountCents": {
                                "type": "uint64",
                                "id": 1,
                                "rule": "optional"
                              },
                              "numberOfEmployees": {
                                "type": "uint32",
                                "id": 2,
                                "rule": "optional"
                              },
                              "payrollHistoryTrunkToken": {
                                "type": "string",
                                "id": 3,
                                "rule": "optional"
                              }
                            }
                          },
                          "NullableBool": {
                            "values": {
                              "NB_DO_NOT_USE": 0,
                              "TRUE": 1,
                              "FALSE": 2,
                              "UNKNOWN": 3
                            }
                          },
                          "PayrollYear": {
                            "values": {
                              "PY_DO_NOT_USE": 0,
                              "USE_2019": 1,
                              "USE_2020": 2,
                              "USE_LAST_12_MONTHS": 3,
                              "USE_NEW_BUSINESS_PERIOD": 4,
                              "USE_SEASONAL_BUSINESS_PERIOD": 5
                            }
                          },
                          "ScheduleCConfirmation": {
                            "values": {
                              "SCC_DO_NOT_USE": 0,
                              "UNCHANGED": 1,
                              "CHANGED": 2,
                              "NOT_SUBMITTED": 3,
                              "SCC_UNKNOWN": 4
                            }
                          },
                          "PppDrawType": {
                            "values": {
                              "PPP_DRAW_TYPE_DO_NOT_USE": 0,
                              "SQUARE_FIRST_DRAW": 1,
                              "SQUARE_SECOND_DRAW": 2,
                              "NON_SQUARE_SECOND_DRAW": 3,
                              "UNVERIFIED_SQUARE_SECOND_DRAW": 4
                            }
                          },
                          "DocboxTokens": {
                            "fields": {
                              "tokens": {
                                "type": "string",
                                "id": 1,
                                "rule": "repeated"
                              }
                            }
                          },
                          "BenefitsDocType": {
                            "values": {
                              "BDT_DO_NOT_USE": 0,
                              "PAYROLL_REPORT_FOR_2019": 1,
                              "PROVIDER_STATEMENTS": 2,
                              "INCLUDED_IN_PAYROLL_REPORT_SUBMITTED": 3
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.capital?.nested?.external?.nested?.business?.nested?.models?.nested?.AfcStatus && !$root.nested?.squareup?.nested?.capital?.nested?.external?.nested?.business?.nested?.models?.nested?.AfcStatus?.nested?.Status && !$root.nested?.squareup?.nested?.capital?.nested?.external?.nested?.business?.nested?.models?.nested?.AfcStatus?.nested?.ReviewStatus && !$root.nested?.squareup?.nested?.capital?.nested?.external?.nested?.business?.nested?.models?.nested?.ControllingIndividual?.nested?.Title && !$root.nested?.squareup?.nested?.capital?.nested?.external?.nested?.business?.nested?.models?.nested?.InformationRequest && !$root.nested?.squareup?.nested?.capital?.nested?.external?.nested?.business?.nested?.models?.nested?.InformationRequest?.nested?.Source && !$root.nested?.squareup?.nested?.capital?.nested?.external?.nested?.business?.nested?.models?.nested?.InformationRequest?.nested?.IrfForm && !$root.nested?.squareup?.nested?.capital?.nested?.external?.nested?.business?.nested?.models?.nested?.InformationRequest?.nested?.SspRequest && !$root.nested?.squareup?.nested?.capital?.nested?.external?.nested?.business?.nested?.models?.nested?.InformationRequest?.nested?.KbaRequest && !$root.nested?.squareup?.nested?.capital?.nested?.external?.nested?.business?.nested?.models?.nested?.FinancingRequest && !$root.nested?.squareup?.nested?.capital?.nested?.external?.nested?.business?.nested?.models?.nested?.FinancingRequest?.nested?.Status && !$root.nested?.squareup?.nested?.capital?.nested?.external?.nested?.business?.nested?.models?.nested?.FinancingRequest?.nested?.PppForgivenessFormType && !$root.nested?.squareup?.nested?.capital?.nested?.external?.nested?.business?.nested?.models?.nested?.PaymentBreakdown && !$root.nested?.squareup?.nested?.capital?.nested?.external?.nested?.business?.nested?.models?.nested?.OfferSimulation && !$root.nested?.squareup?.nested?.capital?.nested?.external?.nested?.business?.nested?.models?.nested?.OfferPayment && !$root.nested?.squareup?.nested?.capital?.nested?.external?.nested?.business?.nested?.models?.nested?.CustomerMaxOfferAmount && !$root.nested?.squareup?.nested?.capital?.nested?.external?.nested?.business?.nested?.models?.nested?.PreviewBoostOffer && !$root.nested?.squareup?.nested?.capital?.nested?.external?.nested?.business?.nested?.models?.nested?.PreviewOffer && !$root.nested?.squareup?.nested?.capital?.nested?.external?.nested?.business?.nested?.models?.nested?.PreviewFinancingRequest && !$root.nested?.squareup?.nested?.capital?.nested?.external?.nested?.business?.nested?.models?.nested?.ProductType && !$root.nested?.squareup?.nested?.capital?.nested?.external?.nested?.business?.nested?.models?.nested?.PreviewPlan && !$root.nested?.squareup?.nested?.capital?.nested?.external?.nested?.business?.nested?.models?.nested?.ApplicationStatus && !$root.nested?.squareup?.nested?.capital?.nested?.external?.nested?.business?.nested?.models?.nested?.ApplicationType && !$root.nested?.squareup?.nested?.capital?.nested?.external?.nested?.business?.nested?.models?.nested?.ReviewType && !$root.nested?.squareup?.nested?.capital?.nested?.external?.nested?.business?.nested?.models?.nested?.PreviewOfferFlow && !$root.nested?.squareup?.nested?.capital?.nested?.external?.nested?.business?.nested?.models?.nested?.EligibilityType && !$root.nested?.squareup?.nested?.capital?.nested?.external?.nested?.business?.nested?.models?.nested?.Eligibility && !$root.nested?.squareup?.nested?.capital?.nested?.external?.nested?.business?.nested?.models?.nested?.Customer && !$root.nested?.squareup?.nested?.capital?.nested?.external?.nested?.business?.nested?.models?.nested?.CustomerEligibility && !$root.nested?.squareup?.nested?.capital?.nested?.external?.nested?.business?.nested?.models?.nested?.CustomerEligibility?.nested?.Status && !$root.nested?.squareup?.nested?.capital?.nested?.external?.nested?.business?.nested?.models?.nested?.CustomerEligibility?.nested?.IneligibleReason && !$root.nested?.squareup?.nested?.capital?.nested?.external?.nested?.business?.nested?.models?.nested?.CustomerEligibility?.nested?.EligibilityToolSection && !$root.nested?.squareup?.nested?.capital?.nested?.external?.nested?.business?.nested?.models?.nested?.CustomerEligibility?.nested?.PaymentVolume && !$root.nested?.squareup?.nested?.capital?.nested?.external?.nested?.business?.nested?.models?.nested?.CustomerEligibility?.nested?.PaymentFrequency && !$root.nested?.squareup?.nested?.capital?.nested?.external?.nested?.business?.nested?.models?.nested?.CustomerEligibility?.nested?.ProcessingVolume && !$root.nested?.squareup?.nested?.capital?.nested?.external?.nested?.business?.nested?.models?.nested?.CustomerEligibility?.nested?.ProcessingFrequency && !$root.nested?.squareup?.nested?.capital?.nested?.external?.nested?.business?.nested?.models?.nested?.CustomerEligibility?.nested?.CustomerMix && !$root.nested?.squareup?.nested?.capital?.nested?.external?.nested?.business?.nested?.models?.nested?.BankAccountData && !$root.nested?.squareup?.nested?.capital?.nested?.external?.nested?.business?.nested?.models?.nested?.PPPOfferFlow && !$root.nested?.squareup?.nested?.capital?.nested?.external?.nested?.business?.nested?.models?.nested?.PPPOfferFlow?.nested?.PayrollCalculationDoc && !$root.nested?.squareup?.nested?.capital?.nested?.external?.nested?.business?.nested?.models?.nested?.PPPOfferFlow?.nested?.SquarePayrollPPPData && !$root.nested?.squareup?.nested?.capital?.nested?.external?.nested?.business?.nested?.models?.nested?.PPPOfferFlow?.nested?.NullableBool && !$root.nested?.squareup?.nested?.capital?.nested?.external?.nested?.business?.nested?.models?.nested?.PPPOfferFlow?.nested?.PayrollYear && !$root.nested?.squareup?.nested?.capital?.nested?.external?.nested?.business?.nested?.models?.nested?.PPPOfferFlow?.nested?.ScheduleCConfirmation && !$root.nested?.squareup?.nested?.capital?.nested?.external?.nested?.business?.nested?.models?.nested?.PPPOfferFlow?.nested?.PppDrawType && !$root.nested?.squareup?.nested?.capital?.nested?.external?.nested?.business?.nested?.models?.nested?.PPPOfferFlow?.nested?.DocboxTokens && !$root.nested?.squareup?.nested?.capital?.nested?.external?.nested?.business?.nested?.models?.nested?.PPPOfferFlow?.nested?.BenefitsDocType) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE AfcStatus @ squareup/capital/external/business/models.proto at 19:1
 */
export const AfcStatus = $root.lookupType('squareup.capital.external.business.models.AfcStatus');
fixType(AfcStatus, {
  customerToken: {
    required: true
  },
  status: {
    required: true
  }
});
Builder.createAndAttachToType(AfcStatus);
/**
 * SOURCE Status @ squareup/capital/external/business/models.proto at 20:3
 */
AfcStatus.Status = $root.lookupEnum('squareup.capital.external.business.models.AfcStatus.Status').values;
/**
 * SOURCE ReviewStatus @ squareup/capital/external/business/models.proto at 34:3
 */
AfcStatus.ReviewStatus = $root.lookupEnum('squareup.capital.external.business.models.AfcStatus.ReviewStatus').values;
/**
 * SOURCE ControllingIndividual @ squareup/capital/external/business/models.proto at 295:1
 */
export const ControllingIndividual = {};
/**
 * SOURCE Title @ squareup/capital/external/business/models.proto at 296:3
 */
ControllingIndividual.Title = $root.lookupEnum('squareup.capital.external.business.models.ControllingIndividual.Title').values;
/**
 * Represents a request for information by Square Capital to a customer.
 *
 * SOURCE InformationRequest @ squareup/capital/external/business/models.proto at 410:1
 */
export const InformationRequest = $root.lookupType('squareup.capital.external.business.models.InformationRequest');
fixType(InformationRequest, {
  isComplete: {
    required: true
  },
  source: {
    required: true
  }
});
Builder.createAndAttachToType(InformationRequest);
/**
 * SOURCE Source @ squareup/capital/external/business/models.proto at 411:3
 */
InformationRequest.Source = $root.lookupEnum('squareup.capital.external.business.models.InformationRequest.Source').values;
/**
 * SOURCE IrfForm @ squareup/capital/external/business/models.proto at 417:3
 */
InformationRequest.IrfForm = $root.lookupType('squareup.capital.external.business.models.InformationRequest.IrfForm');
fixType(InformationRequest.IrfForm, {
  url: {
    required: true
  }
});
Builder.createAndAttachToType(InformationRequest.IrfForm);
/**
 * Currently we do not need any request specfic data to link to the SSP
 * request. We just open the secure profile.
 *
 * SOURCE SspRequest @ squareup/capital/external/business/models.proto at 424:3
 */
InformationRequest.SspRequest = $root.lookupType('squareup.capital.external.business.models.InformationRequest.SspRequest');
fixType(InformationRequest.SspRequest);
Builder.createAndAttachToType(InformationRequest.SspRequest);
/**
 * We need the applicant to complete a KBA quiz before app will be approved
 * so we direct them to complete the quiz
 *
 * SOURCE KbaRequest @ squareup/capital/external/business/models.proto at 429:3
 */
InformationRequest.KbaRequest = $root.lookupType('squareup.capital.external.business.models.InformationRequest.KbaRequest');
fixType(InformationRequest.KbaRequest);
Builder.createAndAttachToType(InformationRequest.KbaRequest);
/**
 * SOURCE FinancingRequest @ squareup/capital/external/business/models.proto at 447:1
 */
export const FinancingRequest = $root.lookupType('squareup.capital.external.business.models.FinancingRequest');
fixType(FinancingRequest, {
  token: {
    required: true
  },
  customerToken: {
    required: true
  },
  status: {
    required: true
  }
});
Builder.createAndAttachToType(FinancingRequest);
/**
 * SOURCE Status @ squareup/capital/external/business/models.proto at 448:3
 */
FinancingRequest.Status = $root.lookupEnum('squareup.capital.external.business.models.FinancingRequest.Status').values;
/**
 * SOURCE PppForgivenessFormType @ squareup/capital/external/business/models.proto at 466:3
 */
FinancingRequest.PppForgivenessFormType = $root.lookupEnum('squareup.capital.external.business.models.FinancingRequest.PppForgivenessFormType').values;
/**
 * SOURCE PaymentBreakdown @ squareup/capital/external/business/models.proto at 568:1
 */
export const PaymentBreakdown = $root.lookupType('squareup.capital.external.business.models.PaymentBreakdown');
fixType(PaymentBreakdown);
Builder.createAndAttachToType(PaymentBreakdown);
/**
 * Corresponding payment data for an offer over a range of dates
 *
 * SOURCE OfferSimulation @ squareup/capital/external/business/models.proto at 592:1
 */
export const OfferSimulation = $root.lookupType('squareup.capital.external.business.models.OfferSimulation');
fixType(OfferSimulation, {
  offerId: {
    required: true
  }
});
Builder.createAndAttachToType(OfferSimulation);
/**
 * SOURCE OfferPayment @ squareup/capital/external/business/models.proto at 600:1
 */
export const OfferPayment = $root.lookupType('squareup.capital.external.business.models.OfferPayment');
fixType(OfferPayment, {
  date: {
    required: true
  },
  totalPaymentAmount: {
    required: true
  },
  totalCapitalPaymentAmount: {
    required: true
  }
});
Builder.createAndAttachToType(OfferPayment);
/**
 * SOURCE CustomerMaxOfferAmount @ squareup/capital/external/business/models.proto at 622:1
 */
export const CustomerMaxOfferAmount = $root.lookupType('squareup.capital.external.business.models.CustomerMaxOfferAmount');
fixType(CustomerMaxOfferAmount, {
  maxFinancedAmount: {
    required: true
  },
  customerToken: {
    required: true
  }
});
Builder.createAndAttachToType(CustomerMaxOfferAmount);
/**
 * SOURCE PreviewBoostOffer @ squareup/capital/external/business/models.proto at 628:1
 */
export const PreviewBoostOffer = $root.lookupType('squareup.capital.external.business.models.PreviewBoostOffer');
fixType(PreviewBoostOffer);
Builder.createAndAttachToType(PreviewBoostOffer);
/**
 * SOURCE PreviewOffer @ squareup/capital/external/business/models.proto at 643:1
 */
export const PreviewOffer = $root.lookupType('squareup.capital.external.business.models.PreviewOffer');
fixType(PreviewOffer, {
  offerSetId: {
    required: true
  }
});
Builder.createAndAttachToType(PreviewOffer);
/**
 * SOURCE PreviewFinancingRequest @ squareup/capital/external/business/models.proto at 680:1
 */
export const PreviewFinancingRequest = $root.lookupType('squareup.capital.external.business.models.PreviewFinancingRequest');
fixType(PreviewFinancingRequest, {
  financingRequestId: {
    required: true
  }
});
Builder.createAndAttachToType(PreviewFinancingRequest);
/**
 * SOURCE ProductType @ squareup/capital/external/business/models.proto at 704:1
 */
export const ProductType = $root.lookupEnum('squareup.capital.external.business.models.ProductType').values;
/**
 * SOURCE PreviewPlan @ squareup/capital/external/business/models.proto at 720:1
 */
export const PreviewPlan = $root.lookupType('squareup.capital.external.business.models.PreviewPlan');
fixType(PreviewPlan, {
  planId: {
    required: true
  }
});
Builder.createAndAttachToType(PreviewPlan);
/**
 * SOURCE ApplicationStatus @ squareup/capital/external/business/models.proto at 751:1
 */
export const ApplicationStatus = $root.lookupEnum('squareup.capital.external.business.models.ApplicationStatus').values;
/**
 * SOURCE ApplicationType @ squareup/capital/external/business/models.proto at 759:1
 */
export const ApplicationType = $root.lookupEnum('squareup.capital.external.business.models.ApplicationType').values;
/**
 * SOURCE ReviewType @ squareup/capital/external/business/models.proto at 765:1
 */
export const ReviewType = $root.lookupEnum('squareup.capital.external.business.models.ReviewType').values;
/**
 * SOURCE PreviewOfferFlow @ squareup/capital/external/business/models.proto at 771:1
 */
export const PreviewOfferFlow = $root.lookupType('squareup.capital.external.business.models.PreviewOfferFlow');
fixType(PreviewOfferFlow, {
  offerFlowId: {
    required: true
  }
});
Builder.createAndAttachToType(PreviewOfferFlow);
/**
 * SOURCE EligibilityType @ squareup/capital/external/business/models.proto at 782:1
 */
export const EligibilityType = $root.lookupEnum('squareup.capital.external.business.models.EligibilityType').values;
/**
 * SOURCE Eligibility @ squareup/capital/external/business/models.proto at 796:1
 */
export const Eligibility = $root.lookupType('squareup.capital.external.business.models.Eligibility');
fixType(Eligibility, {
  type: {
    required: true
  }
});
Builder.createAndAttachToType(Eligibility);
/**
 * SOURCE Customer @ squareup/capital/external/business/models.proto at 802:1
 */
export const Customer = $root.lookupType('squareup.capital.external.business.models.Customer');
fixType(Customer, {
  id: {
    required: true
  }
});
Builder.createAndAttachToType(Customer);
/**
 * SOURCE CustomerEligibility @ squareup/capital/external/business/models.proto at 890:1
 */
export const CustomerEligibility = $root.lookupType('squareup.capital.external.business.models.CustomerEligibility');
fixType(CustomerEligibility);
Builder.createAndAttachToType(CustomerEligibility);
/**
 * SOURCE Status @ squareup/capital/external/business/models.proto at 891:3
 */
CustomerEligibility.Status = $root.lookupEnum('squareup.capital.external.business.models.CustomerEligibility.Status').values;
/**
 * SOURCE IneligibleReason @ squareup/capital/external/business/models.proto at 899:3
 */
CustomerEligibility.IneligibleReason = $root.lookupEnum('squareup.capital.external.business.models.CustomerEligibility.IneligibleReason').values;
/**
 * Used to hide different sections of the eligibility tool
 *
 * SOURCE EligibilityToolSection @ squareup/capital/external/business/models.proto at 924:3
 */
CustomerEligibility.EligibilityToolSection = $root.lookupEnum('squareup.capital.external.business.models.CustomerEligibility.EligibilityToolSection').values;
/**
 * DEPRECATED - replaced by ProcessingVolume
 *
 * SOURCE PaymentVolume @ squareup/capital/external/business/models.proto at 936:3
 */
CustomerEligibility.PaymentVolume = $root.lookupType('squareup.capital.external.business.models.CustomerEligibility.PaymentVolume');
fixType(CustomerEligibility.PaymentVolume);
Builder.createAndAttachToType(CustomerEligibility.PaymentVolume);
/**
 * DEPRECATED - replaced by ProcessingFrequency
 *
 * SOURCE PaymentFrequency @ squareup/capital/external/business/models.proto at 950:3
 */
CustomerEligibility.PaymentFrequency = $root.lookupType('squareup.capital.external.business.models.CustomerEligibility.PaymentFrequency');
fixType(CustomerEligibility.PaymentFrequency);
Builder.createAndAttachToType(CustomerEligibility.PaymentFrequency);
/**
 * SOURCE ProcessingVolume @ squareup/capital/external/business/models.proto at 966:3
 */
CustomerEligibility.ProcessingVolume = $root.lookupType('squareup.capital.external.business.models.CustomerEligibility.ProcessingVolume');
fixType(CustomerEligibility.ProcessingVolume);
Builder.createAndAttachToType(CustomerEligibility.ProcessingVolume);
/**
 * SOURCE ProcessingFrequency @ squareup/capital/external/business/models.proto at 995:3
 */
CustomerEligibility.ProcessingFrequency = $root.lookupType('squareup.capital.external.business.models.CustomerEligibility.ProcessingFrequency');
fixType(CustomerEligibility.ProcessingFrequency);
Builder.createAndAttachToType(CustomerEligibility.ProcessingFrequency);
/**
 * SOURCE CustomerMix @ squareup/capital/external/business/models.proto at 1015:3
 */
CustomerEligibility.CustomerMix = $root.lookupType('squareup.capital.external.business.models.CustomerEligibility.CustomerMix');
fixType(CustomerEligibility.CustomerMix);
Builder.createAndAttachToType(CustomerEligibility.CustomerMix);
/**
 * SOURCE BankAccountData @ squareup/capital/external/business/models.proto at 1053:1
 */
export const BankAccountData = $root.lookupType('squareup.capital.external.business.models.BankAccountData');
fixType(BankAccountData);
Builder.createAndAttachToType(BankAccountData);
/**
 * SOURCE PPPOfferFlow @ squareup/capital/external/business/models.proto at 1061:1
 */
export const PPPOfferFlow = $root.lookupType('squareup.capital.external.business.models.PPPOfferFlow');
fixType(PPPOfferFlow);
Builder.createAndAttachToType(PPPOfferFlow);
/**
 * SOURCE PayrollCalculationDoc @ squareup/capital/external/business/models.proto at 1110:3
 */
PPPOfferFlow.PayrollCalculationDoc = $root.lookupEnum('squareup.capital.external.business.models.PPPOfferFlow.PayrollCalculationDoc').values;
/**
 * SOURCE SquarePayrollPPPData @ squareup/capital/external/business/models.proto at 1133:3
 */
PPPOfferFlow.SquarePayrollPPPData = $root.lookupType('squareup.capital.external.business.models.PPPOfferFlow.SquarePayrollPPPData');
fixType(PPPOfferFlow.SquarePayrollPPPData);
Builder.createAndAttachToType(PPPOfferFlow.SquarePayrollPPPData);
/**
 * SOURCE NullableBool @ squareup/capital/external/business/models.proto at 1173:3
 */
PPPOfferFlow.NullableBool = $root.lookupEnum('squareup.capital.external.business.models.PPPOfferFlow.NullableBool').values;
/**
 * SOURCE PayrollYear @ squareup/capital/external/business/models.proto at 1183:3
 */
PPPOfferFlow.PayrollYear = $root.lookupEnum('squareup.capital.external.business.models.PPPOfferFlow.PayrollYear').values;
/**
 * SOURCE ScheduleCConfirmation @ squareup/capital/external/business/models.proto at 1201:3
 */
PPPOfferFlow.ScheduleCConfirmation = $root.lookupEnum('squareup.capital.external.business.models.PPPOfferFlow.ScheduleCConfirmation').values;
/**
 * SOURCE PppDrawType @ squareup/capital/external/business/models.proto at 1218:3
 */
PPPOfferFlow.PppDrawType = $root.lookupEnum('squareup.capital.external.business.models.PPPOfferFlow.PppDrawType').values;
/**
 * SOURCE DocboxTokens @ squareup/capital/external/business/models.proto at 1229:3
 */
PPPOfferFlow.DocboxTokens = $root.lookupType('squareup.capital.external.business.models.PPPOfferFlow.DocboxTokens');
fixType(PPPOfferFlow.DocboxTokens);
Builder.createAndAttachToType(PPPOfferFlow.DocboxTokens);
/**
 * SOURCE BenefitsDocType @ squareup/capital/external/business/models.proto at 1255:3
 */
PPPOfferFlow.BenefitsDocType = $root.lookupEnum('squareup.capital.external.business.models.PPPOfferFlow.BenefitsDocType').values;